import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { gzip } from 'pako';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  vatAmount: number = 16;
  
  constructor() { }

  Credentials(){
    let creds = `${environment.mileleUser}:${environment.milelePass}`;
    var resultCreds= 'Basic ' + btoa(creds);
    return resultCreds;
  }

  postFormData(url: string, data: FormData, signal?: AbortSignal): any {
    if (!environment.production) console.log(':: URL :: ', url);

    return fetch(url, {
      method: 'POST',
      body: data,
      cache: 'no-store',
      signal, // Pass the AbortSignal here
      headers: {
        'Authorization': this.Credentials(),
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0'
      }
    })
      .then((response) => response.json());
  }

  postRequest(url: string, data: any, filterNulls = true, contentType: string = 'application/json', signal?: AbortSignal): any {
    const requestBody = JSON.stringify(filterNulls ? this.filterNullValues(data) : data);
  
    // Calculate the original payload size in bytes
    const originalSize = new TextEncoder().encode(requestBody).length;
  
    if (!environment.production) console.log(':: URL :: ', url);
  
    let bodyToSend: any;
    let headers: any;
  
    // Define a threshold size for compression (Current: 1 KB = 1024 bytes)
    const compressionThreshold = 20971520;
  
    if (originalSize > compressionThreshold) {
      // Compress the payload using pako.deflate
      const compressedData = gzip(requestBody);

      // Convert Uint8Array to string using TextDecoder
      const decoder = new TextDecoder('utf-8');
      const compressedString = decoder.decode(compressedData);
  
      if (!environment.production) {
        console.log(':: ORIGINAL REQ SIZE :: ', originalSize + ' bytes');
        console.log(':: COMPRESSED REQ SIZE :: ', new TextEncoder().encode(compressedString).length + ' bytes');
        console.log(':: ORIGINAL REQ :: \n', requestBody);
      }
  
      // Set the compressed body and appropriate headers
      bodyToSend = compressedData.buffer;
      headers = {
        'Content-Type': 'application/octet-stream',
        'Content-Encoding': 'gzip', // Indicate that the content is compressed
        'Authorization': this.Credentials(),
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0'
      };
    } else {
      // Use the original body and standard headers for small payloads
      bodyToSend = requestBody;
      headers = {
        'Content-Type': contentType,
        'Authorization': this.Credentials(),
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0'
      };
    }
  
    return fetch(url, {
      method: 'POST',
      body: bodyToSend,
      cache: 'no-store',
      signal, // Pass the AbortSignal here
      headers: headers
    })
      .then((response) => response.json() || response);
  }

  getRequest(url: string, signal?: AbortSignal): any {
    if (!environment.production) console.log(':: URL :: ', url);

    return fetch(url, {
      method: 'GET',
      cache: 'no-store',
      signal, // Pass the AbortSignal here
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.Credentials(),
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0'
      }
    })
      .then((response) => response.json());
  }

  getFile(url: string, signal?: AbortSignal): any {
    if (!environment.production) console.log(':: URL :: ', url);

    return fetch(url, {
      method: 'GET',
      cache: 'no-store',
      signal, // Pass the AbortSignal here
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.Credentials(),
        'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0'
      }
    })
      .then((response) => response.text());
  }

  filterNullValues<T extends { [key: string]: any }>(obj: T): Partial<T> {
    return Object.keys(obj)
      .filter((key: keyof T) => obj[key] !== null)
      .reduce((filteredObj: Partial<T>, key: keyof T) => {
        filteredObj[key] = obj[key];
        return filteredObj;
      }, {});
  }


  // STRIPPED DOWN REQUESTS FOR ADMIN PORTAL
  postGenericRequest(url: string, data: any, headers?: any): any {
    const requestBody = JSON.stringify(this.filterNullValues(data));
    if (!environment.production) console.log(':: URL :: ', url);
  
    return fetch(url, {
      method: 'POST',
      body: requestBody,
      cache: 'no-store',
      headers: headers || {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json() || response);
  }

  getGenericRequest(url: string, headers?: any): any {
    if (!environment.production) console.log(':: URL :: ', url);

    return fetch(url, {
      method: 'GET',
      cache: 'no-store',
      headers: headers || {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => response.json());
  }
}